import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { compose } from 'recompose';

import ggTranslator from 'ggApp/modules/translator';
import VoucherCard from './VoucherCard';

const enhance = compose(
    connect(
        createStructuredSelector({
            translations: ggTranslator.selectors.keys,
        }),
    ),
);

export default enhance(VoucherCard);
